import { createAction } from 'lib/reduxUtils';

export const SET_FEATURE_FLAGS = 'featureFlags/setFeatureFlags';
export const setFeatureFlags = createAction(SET_FEATURE_FLAGS);
